"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const plugin_manager_service_1 = require("../../../service/plugin-manager.service");
class TaskbarComponent {
    constructor(pluginManager) {
        this.pluginManager = pluginManager;
        this.appController = null;
    }
    ngOnInit() {
        this.appController = this.pluginManager.appController;
    }
    removeApp(app = null) {
        if (app) {
            this.appController.delete(app.name);
        }
    }
}
exports.TaskbarComponent = TaskbarComponent;
